import { createSlice } from "@reduxjs/toolkit";
import { EmploymentState } from "./types";
import { fetchJobApplications, fetchVacancies } from "./employment-thunk";
import { ErrorType } from "@/shared/types";

const initialState: EmploymentState = {
    vacancies: [],
    isVacanciesFirstLoad: true,
    isVacanciesLoading: false,
    vacanciesError: null,
    applications: [],
    applicationsError: null,
    isApplicationsLoading: false,
    isApplicationsFirstLoad: true,
    selectedApplicationStatus: "pending"
}

const employmentSlice = createSlice({
    name: 'employment',
    initialState,
    reducers: {},
    extraReducers(builder) {
        builder
        .addCase(fetchJobApplications.pending, (state) => {
            state.isApplicationsLoading = true
            state.applicationsError = null
        })
        .addCase(fetchJobApplications.fulfilled, (state, action) => {
            state.applications = action.payload
            state.isApplicationsFirstLoad = false
            state.isApplicationsLoading = false
            state.applicationsError = null
        })
        .addCase(fetchJobApplications.rejected, (state, action) => {
            state.applicationsError = action.payload as ErrorType ?? null
            state.isApplicationsLoading = false
        })
        .addCase(fetchVacancies.pending, (state) => {
            state.isVacanciesLoading = true
            state.vacanciesError = null
        })
        .addCase(fetchVacancies.fulfilled, (state, action) => {
            state.vacanciesError = null
            state.isVacanciesLoading = false
            state.vacancies = action.payload
            state.isVacanciesFirstLoad = false
        })
        .addCase(fetchVacancies.rejected, (state, action) => {
            state.vacanciesError = action.payload as ErrorType ?? null
            state.isVacanciesLoading = false
        })
    },
})

export default employmentSlice.reducer